import { formatPrice, formatDate } from './formatters';
import { calculateDownpayment } from './calculators';

export const transformListing = (listing) => {
  const newListing = { ...listing };
  
  // Format upset value with dollar sign and comma separators
  if (newListing.upset_value !== null && newListing.upset_value !== undefined && newListing.upset_value !== '') {
    const numericValue = parseFloat(newListing.upset_value);
    if (!isNaN(numericValue)) {
      newListing.upset_value = formatPrice(numericValue);
      newListing.upset_value_numeric = numericValue;
      // Calculate downpayment based on upset value initially
      const downpayment = calculateDownpayment(numericValue);
      newListing.downpayment = formatPrice(downpayment);
      newListing.downpayment_numeric = downpayment;
    } else {
      newListing.upset_value = '$' + newListing.upset_value;
    }
  } else {
    // Handle null/undefined/empty upset values
    newListing.upset_value = 'N/A';
    newListing.upset_value_numeric = 0;
    newListing.downpayment = 'N/A';
    newListing.downpayment_numeric = 0;
    // Set default profit values
    newListing.profit = 0;
    newListing.profitFormatted = 'N/A';
    newListing.profitPercentage = 0;
  }
  
  // Format sale date
  if (newListing.sale_date) {
    try {
      const date = new Date(newListing.sale_date);
      newListing.sale_date = formatDate(newListing.sale_date);
      newListing.sale_date_raw = date.getTime();
      
      if (newListing.status && newListing.status.includes('Adjourned')) {
        newListing.isAdjourned = true;
      }
    } catch (e) {
      console.error('Date formatting error:', e);
    }
  }
  
  return newListing;
};

export const transformListings = (listings) => {
  return listings.map(transformListing);
};

export const updateListingWithPropertyData = (listing, propertyData) => {
  // Handle both successful data and simulated data
  if ((propertyData?.status === 'success' || propertyData?.status === 'no_data') && propertyData.data && propertyData.data.estimatedValue) {
    const marketValue = propertyData.data.estimatedValue;
    const upsetValue = listing.upset_value_numeric || 0;
    
    return {
      ...listing,
      marketValue,
      marketValueFormatted: formatPrice(marketValue),
      dataSource: propertyData.data.source,
      // Keep downpayment based on upset value (not market value)
      // downpayment and downpayment_numeric are already calculated in transformListing
      // Calculate profit
      profit: marketValue - upsetValue,
      profitFormatted: upsetValue > 0 ? `${marketValue - upsetValue > 0 ? '+' : ''}${formatPrice(Math.abs(marketValue - upsetValue))}` : 'N/A',
      profitPercentage: upsetValue > 0 ? ((marketValue - upsetValue) / upsetValue * 100) : 0
    };
  }
  return listing;
};